import Dialog from "dialog";
import template from "./dialog-config.html";
import css from "./dialog-config.css";
import {Label}  from "gui";
import DialogDevice from "../dialog-device.js";

class ConfigValve1i2oDialog extends DialogDevice {
  static get template() {
    return template;
  }
  static get css() {
    return css;
  }
  static constructor() {
    customElements.define("fulljs-dialog-config-valve-1i2o", ConfigValve1i2oDialog);
  }
  connectedCallback() {
    super.connectedCallback();

    this.dropDownListDirection.value = application.devices[this.name].value;
  }
  constructor(...args) {    
    super(...args);
    
    this.show();
  }
  async updatedevice(device) {
    await super.updatedevice(device);

    this.textboxMaximalCapacity.value = `${device.maximalCapacity} ${device.capacityUnit}`;
  }
  async dropDownListDirection_change() {
    try {
      await server.rcall(`RM_${this.endpoint}_setValue`, this.dropDownListDirection.value);
    } catch(e) {
      alert(e);
    }
  }
}

ConfigValve1i2oDialog.constructor();

export default ConfigValve1i2oDialog;